import { useAuth } from "../App";

/**
 * Convenience hook for subscription/billing state.
 * Reads from the subscription object in AuthContext.
 */
export function useSubscription() {
  const { subscription, fetchSubscription } = useAuth();

  const isPro =
    subscription?.plan_type === "pro" &&
    subscription?.subscription_status === "active";

  const isTrialActive = subscription?.trial_active ?? false;
  const trialDaysRemaining = subscription?.trial_days_remaining ?? 0;
  const isTrialExpired = !isTrialActive && !isPro;
  const postsUsedToday = subscription?.posts_used_today ?? 0;
  const postsRemainingToday = subscription?.posts_remaining_today ?? null; // null = unlimited

  return {
    subscription,
    isPro,
    isTrialActive,
    trialDaysRemaining,
    isTrialExpired,
    postsUsedToday,
    postsRemainingToday,
    refetch: fetchSubscription,
  };
}
